__turbopack_context__.v({
  "blinkTwice": "DraggableWindow-module-scss-module__mSrgVq__blinkTwice",
  "collapseWindow": "DraggableWindow-module-scss-module__mSrgVq__collapseWindow",
  "draggableWindow": "DraggableWindow-module-scss-module__mSrgVq__draggableWindow",
  "draggableWindowWrapper": "DraggableWindow-module-scss-module__mSrgVq__draggableWindowWrapper",
  "expandFromTopLeft": "DraggableWindow-module-scss-module__mSrgVq__expandFromTopLeft",
  "expandWindow": "DraggableWindow-module-scss-module__mSrgVq__expandWindow",
  "media": "DraggableWindow-module-scss-module__mSrgVq__media",
  "mediaContainer": "DraggableWindow-module-scss-module__mSrgVq__mediaContainer",
  "navigation-back": "DraggableWindow-module-scss-module__mSrgVq__navigation-back",
  "navigation-next": "DraggableWindow-module-scss-module__mSrgVq__navigation-next",
  "shrinkToTopLeft": "DraggableWindow-module-scss-module__mSrgVq__shrinkToTopLeft",
  "title": "DraggableWindow-module-scss-module__mSrgVq__title",
});
